function getBizGubun(bizNo) {
    // P: 개인 C:법인
    if (bizNo) {
        if (/^[0-9]{3}[0-7][0-9][0-9]{5}$/.test(bizNo)) {
            // 개인사업자(과세) 0~79
            return "P";
        } else if (/^[0-9]{3}80[0-9]{5}$/.test(bizNo)) {
            // 비사업자 80
            return "P";
        } else if (/^[0-9]{3}(81|86|87|88)[0-9]{5}$/.test(bizNo)) {
            // 영리법인(본점) 81,86,87,88
            return "C";
        } else if (/^[0-9]{3}82[0-9]{5}$/.test(bizNo)) {
            // 비영리법인 82
            return "C";
        } else if (/^[0-9]{3}83[0-9]{5}$/.test(bizNo)) {
            // 국가 기관 및 지방 자치단체 83
            return "C";
        } else if (/^[0-9]{3}84[0-9]{5}$/.test(bizNo)) {
            // 외국법인 84
            return "C";
        } else if (/^[0-9]{3}85[0-9]{5}$/.test(bizNo)) {
            // 영리법인(지점) 85
            return "C";
        } else if (/^[0-9]{3}89[0-9]{5}$/.test(bizNo)) {
            // 종교단체 89
            return "P";
        } else if (/^[0-9]{3}9[0-9][0-9]{5}$/.test(bizNo)) {
            // 개인사업자(면세) 90~99
            return "P";
        }
    }
}

/**
 * @param {*} data 스크래핑 데이터 원본
 * @returns 사업자번호, 주민번호
 */
function getTxprDscmNoEncCntn(data) {
    const bizNo = data?.data?.bmanBscInfrInqrDVO?.txprDscmNoEncCntn;
    if (bizNo) {
        if (bizNo.length == 10) {
            return `${bizNo.substring(0, 3)}-${bizNo.substring(3, 5)}-${bizNo.substring(5, 10)}`;
        } else if (bizNo.length == 13) {
            return `${bizNo.substring(0, 6)} -${bizNo.substring(6, 13)}`;
        }
    }
    return bizNo;
}

function getUserBizNo(data) {
    return data?.data?.bmanBscInfrInqrDVO?.txprDscmNoEncCntn ?? "";
}

/**
 * @param {*} data 스크래핑 데이터 원본
 * @returns 상호 혹은 대표자명
 */
function getTxprNm(data) {
    const txprNm = data?.data?.bmanBscInfrInqrDVO?.txprNm;
    return txprNm ? txprNm.trim() : data?.data?.bmanBscInfrInqrDVO?.rprsTxprNm.trim();
}

/**
 * @param {*} data 스크래핑 데이터 원본
 * @returns 사업자유형
 */
function getBmanClNm(data) {
    const bmanClNm = data?.data?.bmanBscInfrInqrDVO?.bmanClNm;
    if (bmanClNm) {
        return bmanClNm.replaceAll(" ", "").replaceAll("(", "").replaceAll(")", "");
    }
}

/**
 * @param {*} data 스크래핑 데이터 원본
 * @returns 대표자명
 */
function getRprsTxprNm(data) {
    const jntBmanCnt = data?.data?.cerIsnInqrSVO?.jntBmanCnt ?? 0;
    let jntRprsList = "";

    if (getBizGubun(data?.data?.bmanBscInfrInqrDVO?.txprDscmNoEncCntn) == "C") {
        jntRprsList = data?.data?.cerIsnInqrSVO?.jntRprsList ?? "";
    } else {
        const list = data?.data?.jntBmanRprsCtlInqrOneDVOList;
        const rows = list?.rows;

        // rows가 배열인지 혹은 객체인지 확인
        // 공동대표자가 1명일 경우 객체, 2명 이상일 경우 배열
        if (Array.isArray(rows)) {
            const result = rows
                .map(row => row.txprNm)
                .filter(Boolean);   // 빈값은 제거

            if (result.length > 0) {
                jntRprsList = `(${result.join(",")})`;
            }
        } else if (rows) {
            // 객체일 경우, 그냥 row에서 직접 'txprNm' 속성을 가져옴
            const txprNm = rows.txprNm;
            if (txprNm) {
                jntRprsList = `(${rows.txprNm})`;
            }
        }
    }

    // 공동대표자 포함 최대 5인까지 같이 보이도록 처리
    let rprsTxprNm = data?.data?.bmanBscInfrInqrDVO?.rprsTxprNm ?? "";
    if (jntBmanCnt > 0 && jntRprsList) {
        const jntRprsNames = jntRprsList.replace(/[()]/g, "").split(",");
        jntRprsNames.forEach((name, index) => {
            if (index === 4) {
                rprsTxprNm += ` 외 ${jntBmanCnt - 4}명`;
                return;
            }
            rprsTxprNm += `/${name}`;
        });
    }
    return rprsTxprNm;
}

/**
 * @param {*} data 스크래핑 데이터 원본
 * @returns 전송대상 주민번호
 */
function getRprsResno(data) {
    return data?.data?.bmanBscInfrInqrDVO?.rprsResno;
}

/**
 * @param {*} data 스크래핑 데이터 원본
 * @returns 전송자사업자번호
 */
function getAgentBsno(data) {
    return data?.usrInfo?.txprDscmNo;
}

/**
 * @param {*} data 스크래핑 데이터 원본
 * @returns 전송자 상호 혹은 이름
 */
function getAgentNm(data) {
    // userNm : 상호명
    // rprsFnm : 대표자명
    return data?.usrInfo?.userNm ?? data?.usrInfo?.rprsFnm;
}

//주소정보 
function getJusoCode(data) {
    return data?.data?.bmanBscInfrInqrDVO.sggCd;
}
function getJusoSido(data) {
    return data?.data?.bmanBscInfrInqrDVO.roadSidoNm;
}
function getJusoSigu(data) {
    return data?.data?.bmanBscInfrInqrDVO.roadSggNm;
}
function getJusoRoad(data) {
    return data?.data?.bmanBscInfrInqrDVO.roadNm;
}
function getJusoPriNo(data) {
    return data?.data?.bmanBscInfrInqrDVO.bldPmnoAdr;
}
function getJusoSubNo(data) {
    return data?.data?.bmanBscInfrInqrDVO.bldSnoAdr;
}
function getJusofullAddr(data) {
    return data?.data?.bmanBscInfrInqrDVO.roadAdr;
}
function getTelNo(data) {
    const telNo = data?.data?.cerpBscInfrDVO.cvaChrgTelno;
    if (telNo) {
        return telNo.split("-");
    } else {
        return ["", "", ""];
    }
}
export {
    getBizGubun, getUserBizNo, getTxprDscmNoEncCntn, getTxprNm, getBmanClNm, getRprsTxprNm, getRprsResno, getAgentBsno, getAgentNm,
    getJusoCode, getJusoSido, getJusoSigu, getJusoRoad, getJusoPriNo, getJusoSubNo, getJusofullAddr, getTelNo
};